//文件下放入你所需用到的组件即可，这里我是用了 Button 
import Vue from 'vue';
import Vant from 'vant';
import {
    Button
} from 'vant';
import {
    Swipe,
    SwipeItem
} from 'vant';
import {
    Lazyload
} from 'vant';
import {
    Cell,
    CellGroup
} from 'vant';
import {
    Field
} from 'vant';
import {
    Form
} from 'vant';
import {
    Area
} from 'vant';
import {
    Popup
} from 'vant';
import {
    Picker
} from 'vant';
import { Toast } from 'vant';
Vue.use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Form);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Toast);
